import { useIsPermitted } from './useIsPermitted'
import { PERMISSIONS } from 'interfaces/permissions/permissions'

export const useIsCurrentUserOrgAdmin = (): boolean | null => {
  const { isPermitted, isPermissionsLoading } = useIsPermitted()
  return isPermissionsLoading ? null : isPermitted(PERMISSIONS.ORG_ADMIN)
}
